<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="" icon="format-list-bulleted">
			<div>
				<radio-picker class="mb-15" :options="categories" v-model="categoryId"></radio-picker>
			</div>
			<div>
				<radio-picker :options="types" v-model="typeId"></radio-picker>
			</div>

			<div v-show="typeId === '1'" class="horizontal-center mt-20">
				<date-select :dateProvided="start" :isDateShow="false" :years="years" @change="onStartInput"></date-select>
				<div class="ml-20 mr-20">～</div>
				<date-select :dateProvided="end" :isDateShow="false" :years="years" @change="onEndInput"></date-select>
			</div>

			<div>
				<b-button type="is-info" class="mt-30" :loading="isSummaryLoading" @click="onSummaryButtonClick">CSV出力</b-button>
			</div>
		</card-component>
	</div>

</template>

<style lang="scss" scoped>
.card {
	padding: 20px;
}
</style>

<script>
import qs from 'qs';
import moment from 'moment'
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'
import DateSelect from '@/components/DateSelect'
import RadioPicker from '@/components/RadioPicker'

export default {
	name: 'Summary',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
		DateSelect,
		RadioPicker,
	},
	data() {
		return {
			isSummaryLoading: false,
			typeId: '0',
			categoryId: '0',
			categories: {
				'0': 'スタッフ',
				'1': 'チーム',
			},
			types: {
				'0': '今月',
				'1': '期間指定',
				'2': '全期間',
			},
			start: moment().format('YYYY-MM'),
			end: moment().format('YYYY-MM'),
			years: [],
		}
	},
	computed: {
		titleStack () {
			return [
				'集計'
			]
		},
	},
	created() {
		for (let i = moment().year(); i >= 2019; i--) {
			this.years.push(i);
		}
	},
	mounted() {
	},
	methods: {
		onEndInput: function(date) {
			this.end = date;
		},
		onStartInput: function(date) {
			this.start = date;
		},
		onSummaryButtonClick: async function() {
			this.isSummaryLoading = true;

			let data = {
				"type_id": this.typeId,
				"start": this.start,
				"end": this.end,
			};

			let ep = this.categoryId === '0' ? 'staffs/summary' : 'teams/summary';
			ep += '?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.downloadCSV(res.data);
			} catch (error) {
				this.$utils.log(error);
				alert(error.response.data.message);
			} finally {
				this.isSummaryLoading = false;
			}
		},
		downloadCSV: function(data) {
			let category = this.categoryId === '0' ? 'staff' : 'team';
			let fileName = `export_summary_${category}.csv`;
			this.$utils.downloadCSV(data, fileName, true);
		},
	},
}
</script>
